export default {
    BackendUrl:                   'https://backend-staging.talenyanetwork.com',
    ENVIRONMENT:                  'staging',
    NODE_ENV:                     'staging',
    inlinemanual:                 true,
    WebAppUrl:                    'https://staging.webapp.talenyanetwork.com'
};
